import axios from 'axios';
import {useState, useEffect} from 'react';

import {URLS} from '../config';
import { SonsType } from '../types/SonsType';

export const useGetSons = () => {
  const [sons, setSons] = useState<SonsType[]>([]);
  const [sonsLoading, setSonsLoading] = useState<boolean>(false);

  const getSons = async () => {
    setSonsLoading(true);

    try {
      const response = await axios.get(URLS.GET_SONS_LOCAL);
      setSons(response.data.sons);
    } catch (error) {
      console.error(error);
    } finally {
      setSonsLoading(false);
    }
  };

  useEffect(() => {
    getSons();
  }, []);

  return {sonsLoading, sons};
};
